import { DATA_ITEMS } from './items.js';
import { DATA_QUESTS_A } from './quests-a.js';
import { DATA_QUESTS_B } from './quests-b.js';
import { DATA_QUESTS_C } from './quests-c.js';
import { DATA_RAID } from './raid.js';
import { DATA_WORLD } from './world.js';

/**
 * The English of the game data (ADR 0069, step 3): names and lines of items,
 * creatures, spells, quests, achievements, offers and places, keyed by the
 * exact French text as `@shefira/shared` writes it. `localize-data.ts` puts
 * it in place at start; `uiText` reads it too, for a text copied before.
 */
export const DATA_EN: Readonly<Record<string, string>> = {
  ...DATA_ITEMS,
  ...DATA_WORLD,
  ...DATA_QUESTS_A,
  ...DATA_QUESTS_B,
  ...DATA_QUESTS_C,
  ...DATA_RAID,
};
